import { SettingsModal } from '@components/containers/settings';
import AppLayout from '@layouts/AppLayout';
import { useState, type FC } from 'react';
import { useNavigate } from 'react-router';

const Settings: FC = () => {
    const [open, setOpen] = useState(true);
    const navigate = useNavigate();

    const handleClose = () => {
        setOpen(false);
        navigate('/home');
    };

    return (
        <AppLayout>
            <SettingsModal opened={open} onClose={handleClose} />
        </AppLayout>
    );
};

export default Settings;
